import { render } from "./DiscountList.vue?vue&type=template&id=6c0ed12a&scoped=true"
import script from "./DiscountList.vue?vue&type=script&lang=js"
export * from "./DiscountList.vue?vue&type=script&lang=js"

import "./DiscountList.vue?vue&type=style&index=0&id=6c0ed12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0ed12a"]])

export default __exports__